import { InvoiceUploaderService } from './invoice-uploader.service';

export const services = [InvoiceUploaderService];

export * from './invoice-uploader.service';
